module.exports = __webpack_public_path__ + "img/9.c96085e5.png";